import { z } from "zod";
import { Holding } from "../../queries/holdings/holding.js";

export const Request = z.object({
  source: Holding.omit({ quantity: true }),
  destinations: Holding.array().min(1),
  reason: z.string().min(1),
});

export type Request = z.infer<typeof Request>;
